import { css } from 'styled-components';
import StandUtils from '../utils/standUtils';

const getMargin = props => {
  if (props.margin) return props.margin;
  if (props.m) return props.m;
  if (props.my) return `${props.my} 0 ${props.my} 0`;
  if (props.mx) return `0 ${props.mx} 0 ${props.mx}`;
  if (props.mt) return `${props.mt} 0 0 0`;
  if (props.mb) return `0 0 ${props.mb} 0`;
  if (props.mr) return `0 ${props.mr} 0 0`;
  if (props.ml) return `0 0 0 ${props.ml}`;
  return '0';
};

const getPadding = props => {
  if (props.padding) return props.padding;
  if (props.p) return props.p;
  if (props.py) return `${props.py} 0 ${props.py} 0`;
  if (props.px) return `0 ${props.px} 0 ${props.px}`;
  if (props.pt) return `${props.pt} 0 0 0`;
  if (props.pb) return `0 0 ${props.pb} 0`;
  if (props.pr) return `0 ${props.pr} 0 0`;
  if (props.pl) return `0 0 0 ${props.pl}`;
  return '0';
};

const getWidth = props => {
  if (props.width) return props.width;
  if (props.w) return props.w;
  return 'auto';
};

const getMinWidth = props => {
  if (props.minWidth) return props.minWidth;
  if (props.minw) return props.minw;
  return 'initial';
};

const getMaxWidth = props => {
  if (props.maxWidth) return props.maxWidth;
  if (props.maxw) return props.maxw;
  return 'none';
};

const getHeight = props => {
  if (props.height) return props.height;
  if (props.h) return props.h;
  return 'auto';
};

const getMinHeight = props => {
  if (props.minHeight) return props.minHeight;
  if (props.minh) return props.minh;
  return 'auto';
};

const getMaxHeight = props => {
  if (props.maxHeight) return props.maxHeight;
  if (props.maxh) return props.maxh;
  return 'none';
};

const size = css`
  width: ${props => getWidth(props)};
  min-width: ${props => getMinWidth(props)};
  max-width: ${props => getMaxWidth(props)};
  height: ${props => getHeight(props)};
  min-height: ${props => getMinHeight(props)};
  max-height: ${props => getMaxHeight(props)};
`;

const space = css`
  padding: ${props => getPadding(props)};
  margin: ${props => getMargin(props)};
`;

const text = css`
  font-size: ${props => props.fontSize || '14px'};
  font-weight: ${props => props.fontWeight || 'normal'};
  font-style: ${props => props.fontStyle || 'normal'};
  line-height: ${props => props.lineHeight || '1'};
  letter-spacing: ${props => props.letterSpacing || 'normal'};
`;

const url = absolutePath => {
  return `url(${StandUtils.getUIPath()}/images/${absolutePath})`;
};

export { space, size, text, url };



// WEBPACK FOOTER //
// ./src/components/mixins.js